<template>
	<div class="content_wrap">
		<div class="warp_box clearfix">
			<div class="left_box">
				<div class="title">API说明</div>
				<div class="list" v-html='html'></div>
			</div>
			<api-content :content='content' :fileName='fileName'></api-content>
		</div>
	</div>

</template>

<script>
	import ApiContent from '@/components/public/ApiContent'
	export default {
		name: 'resourceCenter',
		data() {
			return {
				html: '',
				content: '',
				fileName:''
			}
		},
		methods: {},
		components: {
			ApiContent
		},
		mounted() {
//			this.check.checkSession(this);
			var that = this;
			let cacheUrl =  sessionStorage.getItem('apiIndex') || "apiIndex";
			
			let url = cacheUrl.replace("/","");
			//渲染左侧菜单
			this.http.get(FINANCE_PREFIX + '/document/getFile?fileName=ystApiShowCatalog', res => {
//				that.list = res.data;
				if(!res.data){
					return false
				}
				var data = JSON.parse(res.data);
				let html = "";
				for(var i in data) {
					html += ` 
		       		<div class='first_title'>${i}<i class="nav-icon"></i></div>
					<ul class='first_box' style = 'display:none'>
					`
					if(data[i] instanceof Array) {
						for(var j = 0, len = data[i].length; j < len; j++) {
							if(data[i][j].url) {
								html += `<li class='second_item' attr='${data[i][j].url}'>${data[i][j].Chinese_name}</li>`
							} else {
								html += ` 
					       		<div class='second_title'>${data[i][j].name}<i class="nav-icon"></i></div>
								<ul class='second_box' style = 'display:none'>
							`
								for(var z = 0, length = data[i][j].content.length; z < length; z++) {
									html += `<li title ="${data[i][j].content[z].Chinese_name}" class='third_item' attr='${data[i][j].content[z].url}'>${data[i][j].content[z].Chinese_name}</li>`
								}
								html += `</ul>`
							}
						}
					} else {
						for(var x in data[i]) {
							html += ` 
					       		<div class='second_title'>${x}<i class="nav-icon"></i></div>
								<ul class='second_box' style = 'display:none'>
							 `
							for(var z = 0, length = data[i][x].length; z < length; z++) {
								html += `<li class='third_item' attr='${data[i][x][z].url}'>${data[i][x][z].Chinese_name}</li>`
							}
							html += `</ul>`
						}
					}
					html += `</ul>`
				}
				that.html = html;
				that.init(url);
				$('.title').addClass('active');
				//缓存页面
				setTimeout(function(){
					$.each($('.second_item,.third_item'), function(index, obj) {
						if($(obj).attr('attr') == cacheUrl){
							$('.third_item,.second_item').removeClass('active');
							$('.title').removeClass('active');
							$(obj).addClass('active');
							$(obj).parent().show().prev().children(".nav-icon").addClass('nav-icon-active');
							if($(obj).hasClass('third_item')){
								$(obj).parent().parent().show().children(".nav-icon").addClass('nav-icon-active');					
							}
						}
					})
				})
				//一级二级菜单点击效果
				$('.list').on('click', '.first_title,.second_title', function() {
					if($(this).hasClass('first_title')){
						$('.first_title').children(".nav-icon").removeClass('nav-icon-active');
					}else{
						$('.second_title').children(".nav-icon").removeClass('nav-icon-active');
					}
					$(this).siblings('.first_title,.second_title').next().slideUp();
					if($(this).next().css('display') == "none") {
						$(this).next().slideDown();
						$(this).children(".nav-icon").addClass('nav-icon-active');
					} else {
						$(this).children(".nav-icon").removeClass('nav-icon-active');
						$(this).next().slideUp();
					}
				})
				//点击标题显示效果
				$('.content_wrap').on('click', '.title', function() {
					$('.first_title').children(".nav-icon").removeClass('nav-icon-active');
					$('.second_title').children(".nav-icon").removeClass('nav-icon-active');
					$('.third_item,.second_item').removeClass('active');
					$('.first_title,.second_title').next().slideUp();
					$(this).addClass('active');
					that.init('apiIndex')
				})
				//选中项显示效果
				$('.list').on('click', '.third_item,.second_item', function() {
					$('.third_item,.second_item').removeClass('active');
					$(this).addClass('active');
					$('.title').removeClass('active');
					url = $(this).attr('attr')
					url=url.replace("/","")
					that.init(url)
				})
				
			})
			
		},
		methods:{
			//填充内容区
			init(url){
				this.$Spin.show({
                    render: (h) => {
                        return h('div', [
                            h('Icon', {
                                'class': 'demo-spin-icon-load',
                                props: {
                                    type: 'load-a',
                                    size: 50
                                }
                            }),
                            h('div', '')
                        ])
                    }
                });
                
				this.http.get(FINANCE_PREFIX + '/document/getFile?fileName='+url, res => {
					this.fileName = url;
					this.content = res.data;
					this.$Spin.hide();
					sessionStorage.setItem('apiIndex',"/" + url)
				})
			}
		}
	}
</script>

<style lang="scss" 	scoped>
	.content_wrap {
		background: $backg;
		padding: 30px 0;
		.warp_box {
			position: relative;
			width: 1200px;
			margin: 0 auto;
			background: $white;
			/*min-height: 887px;*/
			padding: 20px 0;
		}
		.left_box {
			
			float: left;
			width: 220px;
			min-height: 827px;
			font-size: 14px;
			color: $gredF;
			line-height: 40px;
			cursor:pointer;
			.title {
				color: $title;
				padding-left: 20px;
				border-bottom: 1px solid $border;
				/*cursor:pointer;*/
			}
			.list {
				padding-top: 10px;
				min-height: 827px;
			}
			.active {
				background: $white;
				color: $hover;
				border-right: 3px solid $hover;
			}
			.title_active{
				background: $white;
				color: $hover;
				border-right:1px solid  $border;
			}
		}
		
	}
	
	.first_box {
		color: $title;
	}
	
	.first_title {
		position: relative;
		font-size: 14px;
		padding-left: 20px;
		color: $title;
		border-bottom: 1px solid $border;
		&:hover {
			background: $backg;
		}
	}
	
	.second_title,
	.second_item {
		position: relative;
		@include _item
		padding-left: 35px;
		&:hover {
			background: $backg;
		}
	}
	
	.third_item {
		padding-left: 55px;
	}
	
	.third_item,
	.second_item {
		color: $gredF;
		display: block;
		font-size: 14px;
		overflow: hidden;
    		white-space: nowrap;
    		text-overflow:ellipsis;
		@include _item;
		cursor:pointer;
		&:hover {
			background: $backg;

		}
	}
	
</style>



// WEBPACK FOOTER //
// src/page/ResourceCenter.vue